const durationFilters = {
  shorterThan5Mins: 'shorterThan5Mins',
  longerThan30Mins: 'longerThan30Mins'
};
export const toDurationFilter = value => {
  const duration = durationFilters[value];
  return duration || undefined;
};